import React from 'react';

function InsightsDashboard() {
  return (
    <div className="card">
      <h2>Insights Dashboard</h2>
      <p>📊 Mood trends and journal summaries coming soon!</p>
    </div>
  );
}

export default InsightsDashboard;
